import * as Msal from "msal";

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_CLIENT_ID,
    authority: process.env.VUE_APP_AUTHORITY,
    redirectUri: process.env.VUE_APP_SSO_REDIRECT_URL,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};
const msalInstance = new Msal.UserAgentApplication(msalConfig);

export default {
  data() {
    return { msalInstance };
  },
  methods: {
    loginWithMicrosoft() {
      const loginRequest = {
        scopes: ["openid", "profile", "User.Read"],
        redirectUri: process.env.VUE_APP_SSO_REDIRECT_URL,
      };
      this.msalInstance.loginRedirect(loginRequest);
    },
    logoutWithMicrosoft() {
      this.msalInstance.logout();
      localStorage.removeItem("userName");
      localStorage.removeItem("userId");
      localStorage.removeItem("token");
      localStorage.removeItem("time_zone");
      localStorage.removeItem("menu");
      localStorage.removeItem("response");

      this.$message.success("Logout success!", 2);
      this.$router.push("/login");
    },
  },
};
